// extracted by mini-css-extract-plugin
export default {"wrapper":"trips-trip-detail-layout-TripDetailSkeletonLoader__wrapper--4QzFW"};